import axiosInstance from "./AxiosInstance";

const getComingSoon = async () => {
    const response = await axiosInstance.get("/api/coming-soon/");
    return response.data;
}

export default getComingSoon ;